import { render } from "./ProjectsApp.vue?vue&type=template&id=f1734908"
import script from "./ProjectsApp.vue?vue&type=script&lang=js"
export * from "./ProjectsApp.vue?vue&type=script&lang=js"

import "./ProjectsApp.vue?vue&type=style&index=0&id=f1734908&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__